/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { NotificationModelPaginationResult } from '../models/notification-model-pagination-result';
import { NotificationModel } from '../models/notification-model';
@Injectable({
  providedIn: 'root',
})
class NotificationService extends __BaseService {
  static readonly GetNotificationsListPath = '/api/Notification';
  static readonly CreateNotificationPath = '/api/Notification';
  static readonly UpdateNotificationPath = '/api/Notification';
  static readonly GetMyNotificationsListPath = '/api/Notification/mynotification';
  static readonly GetNotificationByIdPath = '/api/Notification/{notificationId}';
  static readonly DeleteNotificationPath = '/api/Notification/{notificationId}';
  static readonly ReadNotificationPath = '/api/Notification/read/{notificationId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `NotificationService.GetNotificationsListParams` containing the following parameters:
   *
   * - `notificationTypeId`:
   *
   * - `Sorting`:
   *
   * - `SearchText`:
   *
   * - `Page`:
   *
   * - `ItemsToSkip`:
   *
   * - `ItemPerPage`:
   *
   * @return Success
   */
  GetNotificationsListResponse(params: NotificationService.GetNotificationsListParams): __Observable<__StrictHttpResponse<NotificationModelPaginationResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.notificationTypeId != null) __params = __params.set('notificationTypeId', params.notificationTypeId.toString());
    if (params.Sorting != null) __params = __params.set('Sorting', params.Sorting.toString());
    if (params.SearchText != null) __params = __params.set('SearchText', params.SearchText.toString());
    if (params.Page != null) __params = __params.set('Page', params.Page.toString());
    if (params.ItemsToSkip != null) __params = __params.set('ItemsToSkip', params.ItemsToSkip.toString());
    if (params.ItemPerPage != null) __params = __params.set('ItemPerPage', params.ItemPerPage.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Notification`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<NotificationModelPaginationResult>;
      })
    );
  }
  /**
   * @param params The `NotificationService.GetNotificationsListParams` containing the following parameters:
   *
   * - `notificationTypeId`:
   *
   * - `Sorting`:
   *
   * - `SearchText`:
   *
   * - `Page`:
   *
   * - `ItemsToSkip`:
   *
   * - `ItemPerPage`:
   *
   * @return Success
   */
  GetNotificationsList(params: NotificationService.GetNotificationsListParams): __Observable<NotificationModelPaginationResult> {
    return this.GetNotificationsListResponse(params).pipe(
      __map(_r => _r.body as NotificationModelPaginationResult)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  CreateNotificationResponse(body?: NotificationModel): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Notification`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  CreateNotification(body?: NotificationModel): __Observable<string> {
    return this.CreateNotificationResponse(body).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  UpdateNotificationResponse(body?: NotificationModel): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Notification`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  UpdateNotification(body?: NotificationModel): __Observable<string> {
    return this.UpdateNotificationResponse(body).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param params The `NotificationService.GetMyNotificationsListParams` containing the following parameters:
   *
   * - `notificationTypeId`:
   *
   * - `Sorting`:
   *
   * - `SearchText`:
   *
   * - `Page`:
   *
   * - `ItemsToSkip`:
   *
   * - `ItemPerPage`:
   *
   * @return Success
   */
  GetMyNotificationsListResponse(params: NotificationService.GetMyNotificationsListParams): __Observable<__StrictHttpResponse<NotificationModelPaginationResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.notificationTypeId != null) __params = __params.set('notificationTypeId', params.notificationTypeId.toString());
    if (params.Sorting != null) __params = __params.set('Sorting', params.Sorting.toString());
    if (params.SearchText != null) __params = __params.set('SearchText', params.SearchText.toString());
    if (params.Page != null) __params = __params.set('Page', params.Page.toString());
    if (params.ItemsToSkip != null) __params = __params.set('ItemsToSkip', params.ItemsToSkip.toString());
    if (params.ItemPerPage != null) __params = __params.set('ItemPerPage', params.ItemPerPage.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Notification/mynotification`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<NotificationModelPaginationResult>;
      })
    );
  }
  /**
   * @param params The `NotificationService.GetMyNotificationsListParams` containing the following parameters:
   *
   * - `notificationTypeId`:
   *
   * - `Sorting`:
   *
   * - `SearchText`:
   *
   * - `Page`:
   *
   * - `ItemsToSkip`:
   *
   * - `ItemPerPage`:
   *
   * @return Success
   */
  GetMyNotificationsList(params: NotificationService.GetMyNotificationsListParams): __Observable<NotificationModelPaginationResult> {
    return this.GetMyNotificationsListResponse(params).pipe(
      __map(_r => _r.body as NotificationModelPaginationResult)
    );
  }

  /**
   * @param notificationId undefined
   * @return Success
   */
  GetNotificationByIdResponse(notificationId: number): __Observable<__StrictHttpResponse<NotificationModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Notification/${encodeURIComponent(String(notificationId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<NotificationModel>;
      })
    );
  }
  /**
   * @param notificationId undefined
   * @return Success
   */
  GetNotificationById(notificationId: number): __Observable<NotificationModel> {
    return this.GetNotificationByIdResponse(notificationId).pipe(
      __map(_r => _r.body as NotificationModel)
    );
  }

  /**
   * @param notificationId undefined
   * @return Success
   */
  DeleteNotificationResponse(notificationId: number): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/Notification/${encodeURIComponent(String(notificationId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param notificationId undefined
   * @return Success
   */
  DeleteNotification(notificationId: number): __Observable<string> {
    return this.DeleteNotificationResponse(notificationId).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param notificationId undefined
   * @return Success
   */
  ReadNotificationResponse(notificationId: number): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Notification/read/${encodeURIComponent(String(notificationId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param notificationId undefined
   * @return Success
   */
  ReadNotification(notificationId: number): __Observable<string> {
    return this.ReadNotificationResponse(notificationId).pipe(
      __map(_r => _r.body as string)
    );
  }
}

module NotificationService {

  /**
   * Parameters for GetNotificationsList
   */
  export interface GetNotificationsListParams {
    notificationTypeId?: string;
    Sorting?: string;
    SearchText?: string;
    Page?: number;
    ItemsToSkip?: number;
    ItemPerPage?: number;
  }

  /**
   * Parameters for GetMyNotificationsList
   */
  export interface GetMyNotificationsListParams {
    notificationTypeId?: string;
    Sorting?: string;
    SearchText?: string;
    Page?: number;
    ItemsToSkip?: number;
    ItemPerPage?: number;
  }
}

export { NotificationService }
